import React from "react";
import { FacilityOrderTemplateNewFlowClinicalEditTemplate } from "themes/application/facility-order-new-flow-clinical/components";
import { observer } from "mobx-react";

@observer
class FacilityOrderTemplateNewFlowClinicalEdit extends React.Component {
	render() {
		return <FacilityOrderTemplateNewFlowClinicalEditTemplate {...this.props} />;
	}
}

export default FacilityOrderTemplateNewFlowClinicalEdit;